<script>
import Repositories from '@/repositories';
const WorkOrderItemsRepository = Repositories.get('workorderitems');
const ItemsRepository = Repositories.get('items');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import WorkOrderPerItemRow from './work-order-per-item-row.vue';

export default {
  components: {
    Loading,
    WorkOrderPerItemRow,
  },
  props: {
    itemIdPublic: String,
    workOrderIdPublic: String,
    typeItem: Number,
    nbItems: Number,
  },
  data() {
    return {
      isLoading: false,
      wasDesynced: false,
      workOrderItemsList: [],
      nbItemsLeft: 0,
    };
  },
  methods: {
    modalHidden() {
      this.wasDesynced = false;
      this.workOrderItemsList = [];
      this.$emit('modal-closed');
    },
    modalShown() {
      this.wasDesynced = false;
      if (this.typeItem == 2) {
        this.nbItemsLeft = this.nbItems;
      }
      this.refreshItems();
    },
    refreshItems() {
      this.workOrderItemsList = [];
      this.isLoading = true;
      let fct = null;

      if (this.typeItem == 1) {
        fct = WorkOrderItemsRepository.customREST.getReservedByItem(
          this.itemIdPublic
        );
      } else if (this.typeItem == 2) {
        fct = WorkOrderItemsRepository.customREST.getRequestedByItem(
          this.itemIdPublic
        );
      } else {
        this.$bvModal.hide('work-orders-per-item-modal');
      }

      if (fct != null) {
        fct
          .then((response) => {
            this.workOrderItemsList = response.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.isLoading = false;
          });
      } else {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
        this.isLoading = false;
      }

      if (this.typeItem == 2 && this.wasDesynced) {
        ItemsRepository.get(this.itemIdPublic)
          .then((resp) => {
            this.nbItemsLeft = this.toFloat(
              resp.data.totalQuantity - resp.data.reservedQuantity
            );
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.isLoading = false;
          });
      }
    },
    errorConnection(statusCode) {
      if (statusCode == 1) {
        this.wasDesynced = true;
        this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgain'));
        this.refreshItems();
      } else {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      }
    },
    woItemRemove(workOrderItem) {
      this.wasDesynced = false;
      let foundIndex = this.workOrderItemsList.findIndex(
        (x) => x.idPublic == workOrderItem.idPublic
      );

      if (this.typeItem == 2) {
        this.nbItemsLeft = this.toFloat(
          this.nbItemsLeft -
            this.toFloat(
              this.workOrderItemsList[foundIndex].requestedQuantity -
                workOrderItem.requestedQuantity
            )
        );
      }

      this.workOrderItemsList.splice(foundIndex, 1);

      if (
        this.typeItem == 2 &&
        (this.workOrderItemsListFiltered.length == 0 || this.nbItemsLeft <= 0)
      ) {
        this.$bvModal.hide('work-orders-per-item-modal');
      }
    },
  },
  computed: {
    workOrderItemsListFiltered() {
      if (this.typeItem == 1) {
        return this.workOrderItemsList.filter(
          (x) => x.workOrderIdPublic != this.workOrderIdPublic
        );
      }

      return this.workOrderItemsList;
    },
    itemTypeName() {
      if (this.typeItem == 1) {
        return this.$t('items.reservedQuantity');
      } else if (this.typeItem == 2) {
        return this.$t('items.requestedQuantity');
      }

      return '';
    },
  },
};
</script>

<template>
  <b-modal
    id="work-orders-per-item-modal"
    scrollable
    size="lg"
    :title="$t('general.reservations')"
    @shown="modalShown()"
    @hidden="modalHidden()"
    ok-variant="danger"
  >
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <h5 v-if="typeItem == 2">
      {{ $t('items.XItemsAvailable').replace('#', nbItemsLeft) }}
    </h5>

    <table class="table table-hover table-nowrap">
      <thead class="thead-light">
        <tr>
          <th class="table-row-expandable">
            {{ $t('workOrders.workOrder') }}
          </th>
          <th class="table-row-relative">
            {{ $t('general.deliveryDate') }}
          </th>
          <th class="table-row-relative">
            {{ itemTypeName }}
          </th>
          <th class="table-row-relative">
            {{ $t('general.action') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          is="WorkOrderPerItemRow"
          v-for="woItem in workOrderItemsListFiltered"
          :key="woItem.idPublic"
          :workOrderItem="woItem"
          :typeItem="typeItem"
          :nbItemsLeft="nbItemsLeft"
          @wo-item-remove="woItemRemove"
          @error-connection="errorConnection"
        ></tr>
      </tbody>
    </table>
    <h3
      class="text-center"
      v-if="workOrderItemsListFiltered.length <= 0 && isLoading == false"
    >
      {{ $t('items.noReservation') }}
    </h3>

    <template #modal-footer>
      <b-button
        @click="$bvModal.hide('work-orders-per-item-modal')"
        size="sm"
        variant="danger"
      >
        {{ $t('general.close') }}
      </b-button>
    </template>
  </b-modal>
</template>

<style scoped>
.bigger-text-size {
  font-size: 1.5em;
}
</style>